export function refreshMapLayout(): void {
  window.dispatchEvent(new Event('resize'));
}
